import { reducer as r } from 'ts-action'
import { on } from 'ts-action-immer'

import * as datatableAction from './store.action'

import { datatableTypes } from '@/typings'

const initalState: datatableTypes.Datatable = {
	col: [],
	data: [],
	page: {
		actual: 1,
		count: 1,
		limit: 10,
	},
	sort: {},
	pending: false,
	endpoint: '',
	show: {
		filter: false,
		filterSwitch: true,
		paginator: true,
		limit: true,
	},
}

export const reducer = r(
	initalState,
	on(datatableAction.getDataStart, (state) => {
		state.pending = true
	}),
	on(datatableAction.getDataSuccess, (state, { payload }) => {
		state.col = payload.col.map((col) => ({
			...col,
			filter: col.filter
				? col.filter.map((filter) => ({
						...filter,
						value: filter.value,
						options: filter.options ? filter.options.map((option) => ({ ...option, value: option.value })) : [],
					}))
				: [],
		}))
		state.data = payload.data
		state.pending = false
		if (payload.page) {
			state.page = payload.page
		}
		if (payload.sort) {
			state.sort = payload.sort
		}
		if (payload.show) {
			state.show = { ...state.show, ...payload.show }
		}
	}),
	on(datatableAction.getDataError, (state) => {
		state.pending = false
	}),

	// SORT
	on(datatableAction.updateSort, (state, { payload: { dataKey } }) => {
		const keys = Object.keys(state.sort)
		const isExist = keys.indexOf(dataKey) > -1
		const isAsc = isExist && state.sort[dataKey] === 'asc'
		const isDesc = isExist && state.sort[dataKey] === 'desc'

		if (!isAsc && !isDesc) {
			state.sort = { ...state.sort, [dataKey]: 'asc' }
			return
		}

		if (isAsc) {
			state.sort = { ...state.sort, [dataKey]: 'desc' }
			return
		}

		if (isDesc) {
			state.sort = { ...state.sort, [dataKey]: 'none' }
			// state.sort = objectHelpers.omit(dataKey, state.sort)
		}
	}),

	// ENDPOINT
	on(datatableAction.updateEndpoint, (state, { payload }) => {
		state.endpoint = payload.endpoint
	}),

	// LIMIT
	on(datatableAction.updateLimit, (state, { payload }) => {
		state.page.limit = payload.limit
	}),

	// PAGE
	on(datatableAction.updatePage, (state, { payload }) => {
		state.page.actual = payload.page
	}),

	// SHOW FILTER
	on(datatableAction.updateShowFilter, (state, { payload }) => {
		state.show.filter = payload.showFilter
	}),

	// FILTER
	on(datatableAction.updateFilter, (state, { payload }) => {
		const index = state.col.findIndex((item) => item.dataKey === payload.col)
		if (index < 0) {
			return
		}
		if (!state.col[index].filter) {
			return
		}

		const filterIndex = state.col[index].filter?.findIndex((item) => item.dataKey === payload.filter.dataKey)
		if (typeof filterIndex === 'undefined' || filterIndex < 0) {
			return
		}

		state.col[index].filter![filterIndex].value = payload.value
	}),

	on(datatableAction.resetFilter, (state) => {
		if (!state.col) {
			return
		}

		state.col = state.col.map((item) => ({
			...item,
			filter: item.filter?.map((filterItem) => ({
				...filterItem,
				value: item.type !== 'date' ? '' : null,
			})),
		}))
		state.show.filter = false
	}),
)
